import { render, staticRenderFns } from "./ui-transition.vue?vue&type=template&id=e47ba82a"
import script from "./ui-transition.vue?vue&type=script&lang=js"
export * from "./ui-transition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports